<template>
  <div class="teacher-wrap">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'TeacherLeave',
  data() {
    return {

    }
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
</style>
